import React, { useState, useEffect } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { DialogAction } from '../../../function/useModal';
import { useTranslation } from 'react-i18next';
import RealtimeSetting from '../../Pages/GroupSettings/RealTimeSetting/RealtimeSettingPage';
import { SettingsState } from '../../organisms/SelectSettings';

type RealtimeSettingDialogProps = {
  dialog: DialogAction<RealtimeSettingDialogResponse>;
  groupNo: number;
};

export type RealtimeSettingDialogResponse = {};

const useStyles = makeStyles(
  createStyles({
    dialog: {
      background: '#FFFFEE',
    },
  })
);

const RealtimeSettingDialog: React.FC<RealtimeSettingDialogProps> = (props: RealtimeSettingDialogProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [mode, setMode] = useState<boolean>(true);
  const [no, setNo] = useState<number>(props.groupNo);
  const [editData, setEditData] = useState<SettingsState>(new SettingsState());
  const [dummyIdx, setDummyIdx] = useState<number>(0);

  useEffect(() => {
    editData.DispatchIndex = setDummyIdx;
  }, [editData]);

  useEffect(() => {
    if (dummyIdx < 0) {
      setIsOpen(false);
      setMode(editData.IsSaveClose);
    }
  }, [dummyIdx]);

  return (
    <>
      <Dialog
        open={isOpen}
        fullScreen={false}
        maxWidth={'xl'}
        onEntered={(e) => {}}
        onExited={(e) => {
          if (mode) {
            props.dialog.apply({});
          } else {
            props.dialog.cancel();
          }
        }}
        PaperProps={{ className: classes.dialog }}
      >
        <DialogTitle>
          {t('RealtimeSettingDialog.リアルタイムトレンドグループ設定', 'リアルタイムトレンドグループ設定')}
        </DialogTitle>
        <DialogContent>
          <RealtimeSetting editData={editData} groupNo={props.groupNo} isDialog={true} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default RealtimeSettingDialog;

//import TrendSettingDialog, { TrendSettingDialogResponse } from '../../molecules/Dialog/TrendSettingDialog';
//const [flgTSDlg, actTSDlg] = useModal<TrendSettingDialogResponse>();
// const tsdlg = flgTSDlg ? <TrendSettingDialog dialog={actTSDlg} groupNo={1} /> : null;
